// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; // Si tu utilises Firestore
import { getStorage } from "firebase/storage"; // Si tu utilises Storage

const firebaseConfig = {
    apiKey: "AIzaSyDr7Fphz6AsZZsAZ7YBD_EzWmmOWDSN-dM",
    authDomain: "tcg-arena-62f15.firebaseapp.com",
    projectId: "tcg-arena-62f15",
    storageBucket: "tcg-arena-62f15.firebasestorage.app",
    messagingSenderId: "1094783707846",
    appId: "1:1094783707846:web:7039da757ea8c6646f85c7"
};

// Initialiser Firebase
const app = initializeApp(firebaseConfig);

// Exporter les services nécessaires
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);